import React from "react";
import {
  Grid,
} from "@mui/material";
import RenderPurchaseData from "./RenderPurchaseData";
import LineChartComp from "./LineChart";
import withRouter from "../../../withRouter";
import { financialyearend, financialyearstart } from "../../../Common/Credentials";
import PurchaseCards from "./PurchaseCards";
import SuppliersPurchasebyYear from "../Yearly/SuppliersPurchasebyYear";
import Payables from "./Payables";

const PurchaseStatistics = ({ data, poloader }) => {
  const [activeChart, setActiveChart] = React.useState("Orders");
  const [ChartType, setChartType] = React.useState("YEAR");

  return (
    <>
      {/* Dashboard Header */}
      <div className="purchase-dashboard-header">Purchase Management</div>

      {/* Summary Cards */}
      <PurchaseCards data={data} poloader={poloader} theme={false} />

      {/* Purchase Orders Statistics Banner */}
      <div className="purchase-stats-banner">
        <div className="banner-header">
          <div className="banner-title">Purchase Orders Statistics</div>
          <div className="banner-toggle">
            <button
              className={`toggle-btn ${activeChart === "GRN" ? "active" : ""}`}
              onClick={() => setActiveChart("GRN")}
            >
              GRN
            </button>
            <button
              className={`toggle-btn ${activeChart === "Orders" ? "active" : ""}`}
              onClick={() => setActiveChart("Orders")}
            >
              Orders
            </button>
          </div>
        </div>

        <RenderPurchaseData
          activeChart={activeChart}
          loader={poloader}
          orders={[
            {
              name: "Today",
              amount: data.todaystotalPOtransaction,
              order: data.totalpotoday,
            },
            {
              name: "This Week",
              amount: data.totalPOtransactionofweek,
              order: data.totalpothisweek,
            },
            {
              name: "This Month",
              amount: data.totalfyPOtransactionofmonth,
              order: data.totalpothismonth,
            },
            {
              name: "This Year",
              amount: data.totalfyPOtransaction,
              order: data.totalpoinfyyear,
            },
          ]}
          invoice={[
            {
              name: "Today",
              amount: data.todaystotalgrntransaction,
              order: data.totalgrntoday,
            },
            {
              name: "This Week",
              amount: data.totalgrntransactionofweek,
              order: data.totalgrnthisweek,
            },
            {
              name: "This Month",
              amount: data.totalfygrntransactionofmonth,
              order: data.totalgrnthismonth,
            },
            {
              name: "This Year",
              amount: data.totalfygrntransaction,
              order: data.totalgrninfyyear,
            },
          ]}
        />
      </div>

      {/* Charts Section */}
      <div className="purchase-charts-container">
        <Grid container>
          <Grid item xs={12} lg={6}>
            <div className="purchase-chart-panel">
              <div className="chart-title">Order vs GRN Amount</div>
              <LineChartComp
                order={
                  ChartType === "YEAR"
                    ? data.yearamount
                    : ChartType === "MONTH"
                      ? data.monthamount
                      : data.weekamount
                }
                invoice={
                  ChartType === "YEAR"
                    ? data.grnyearamount
                    : ChartType === "MONTH"
                      ? data.grnmonthamount
                      : data.grnweekamount
                }
                type={ChartType}
                loader={poloader}
              />
            </div>
          </Grid>
          <Grid item xs={12} lg={6}>
            <div
              className="purchase-chart-panel"
              style={{ borderLeft: "1px solid #e2e8f0" }}
            >
              <div className="chart-title">Purchase Quantity & Amount</div>
              <SuppliersPurchasebyYear
                theme={false}
                start={financialyearstart}
                end={financialyearend}
                loading={poloader}
              />
            </div>
          </Grid>
        </Grid>
      </div>

      {/* Payables Table */}
      <Payables data={data} poloader={poloader} theme={false} />
    </>
  );
};

export default withRouter(PurchaseStatistics);
